export default {"src":"/_next/static/media/user-sign-in.bab1912c.svg","height":32,"width":36,"blurWidth":0,"blurHeight":0};